import { FC } from 'react';

import { getNestedOptionLabel } from '~/core/shared/components/form/NestedSelect';
import { WorkflowStepFormFieldNestedSelect } from '~/core/shared/types';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const NestedSelectFieldToBlock: FieldToBlock<
  'nested_select',
  WorkflowStepFormFieldNestedSelect
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'nested-select',
  componentProps: {
    fieldLabel: field.label,
    options: field.options,
    size: 'sm',
  },
});

type NestedSelectFieldValueProps = FieldValueProps<'nested_select'>;

export const NestedSelectFieldValue: FC<NestedSelectFieldValueProps> = ({
  field,
}) => (
  <>{getNestedOptionLabel(field.options, field.value) ?? field.value ?? '–'}</>
);
